import { NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import BulkPriceEditionModalContent from './BulkPriceEditionModalContent/BulkPriceEditionModalContent';
import { ILogisticServiceProduct } from 'types/services';

interface IUpdatedPrice {
  productIndex: number;
  priceIndex: number;
  priceUsd: number;
  totalValueLocal: number;
  exchangeRate: number;
}

interface IBulkPriceEditionModalProps {
  selectedProducts: ILogisticServiceProduct[];
  currency: string;
  exchangeRate?: number;
  productIndexMap: Map<string | number, { productIndex: number; priceIndex: number }>;
  onUpdateFormPrices: (updatedPrices: IUpdatedPrice[]) => Promise<void>;
  onClose: () => void;
}

const BulkPriceEditionModal = ({
  selectedProducts,
  currency,
  exchangeRate,
  productIndexMap,
  onUpdateFormPrices,
  onClose
}: IBulkPriceEditionModalProps) => {
  const size = selectedProducts?.length || 0;
  const modalTitle = `Editar precios de ${size} productos`;

  return (
    <NudosGenericModal
      modalContent={
        <NudosModalContent
          modalContentTitle={modalTitle}
          hideNudosIcon
          customWidth="580px"
          customHeight="426px"
          toCloseModal={onClose}
          CustomModalComponent={
            <BulkPriceEditionModalContent
              selectedProducts={selectedProducts}
              currency={currency}
              exchangeRate={exchangeRate}
              productIndexMap={productIndexMap}
              onUpdateFormPrices={onUpdateFormPrices}
              onClose={onClose}
            />
          }
        />
      }
    />
  );
};

export default BulkPriceEditionModal;
